import { render, staticRenderFns } from "./DrawerHubTeamDetails.vue?vue&type=template&id=8f3ad560"
import script from "./DrawerHubTeamDetails.vue?vue&type=script&lang=js"
export * from "./DrawerHubTeamDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports